module.exports = __webpack_public_path__ + "img/initial-treatment.481f3854.svg";